/**
 * Copiar enlace del catálogo al portapapeles (clipboard API + fallback execCommand / prompt).
 */

async function copyToClipboard(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* secure context required — try legacy */
  }

  try {
    const el = document.createElement('textarea');
    el.value = text;
    el.setAttribute('readonly', '');
    el.style.cssText = 'position:fixed;top:0;left:0;width:2em;height:2em;opacity:0';
    document.body.appendChild(el);
    el.focus();
    el.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
}

const COPIED_MSG = 'Enlace copiado. Pégalo donde quieras.';

/**
 * @returns {{ ok: boolean, message?: string }}
 */
export async function copyCatalogLink(url) {
  const link = String(url || '').trim();
  if (!link) {
    return { ok: false, message: 'No hay enlace para copiar.' };
  }

  const copied = await copyToClipboard(link);
  if (copied) {
    return { ok: true, message: COPIED_MSG };
  }

  window.prompt('Copia este enlace:', link);
  return { ok: true, message: 'Copia el enlace del cuadro de texto.' };
}
